import { RegistryItem } from "@schemas/agreements/schema";
import WaterwayAgreementForm from "view/agreements/components/form/WaterwayAgreementForm";
import WaterwayAgreementDetails from "view/agreements/components/details/WaterwayAgreementDetails";
import { AgreementTypeEnum, CalculationMethodType, TimeUnit } from "__generated__/graphql";

export const WaterwaySchema: RegistryItem = {
	[AgreementTypeEnum.Waterway]: {
		Form: WaterwayAgreementForm,
		Details: WaterwayAgreementDetails,
		defaultValues: {
			calculationMethod: {
				type: CalculationMethodType.TimeUnit,
				timeUnit: TimeUnit.Day,
			},
		},
		agreementFields: {
			"agreement.manualActionRequired": { rules: { hidden: true } },
			"agreement.costType": { rules: { hidden: true } },
			"agreement.location": { path: "location", rules: { required: true } },
			"agreement.conditions": { rules: { hidden: true } },
		},
		calculationMethodFields: {
			"calculationMethod.type": { rules: { hidden: true } },
			"calculationMethod.timeUnit": { rules: { hidden: true } },
			"calculationMethod.minimumTimeUnitsPayable": { rules: { hidden: true } },
		},
		toInput: (form) => ({
			location: form.location?.id,
		}),
		toForm: (agreement) => ({
			location: agreement.location ?? undefined,
		}),
	},
};
